import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge } from 'rxjs';
import { LayoutService } from '../../../layout.service';
import { Sidebar2ToggleService } from '../../../sidebar.2/sidebar2-toggle.service';
import { MenuName } from './menubar-menu-type.model';
import { MenubarScrollService } from './menubar-scroll.service';

@UntilDestroy()
@Component({
    selector: 'app-menubar-scroll',
    templateUrl: './menubar-scroll.component.html',
    styleUrls: ['./menubar-scroll.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class MenubarScrollComponent {
    @Input() jobHasEstimate: boolean = false;
    @Input() estimateHasJob: boolean = false;
    @Input() menuName: MenuName = MenuName.Estimate;
    @Input() isNewQuoteButtonEnabled = false;

    menubarScrollService = inject(MenubarScrollService);
    layoutService = inject(LayoutService);
    sideBarToggle = inject(Sidebar2ToggleService);

    ngOnInit() {
        this.#setCursors();
        merge(this.layoutService.isMobile$, this.sideBarToggle.sidebarToggle)
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.menubarScrollService.reset();
                this.#setMenuPositions();
                this.#setCursors();
            });
    }

    #setCursors() {
        if (this.menuName === MenuName.Job) {
            this.menubarScrollService.atRightEnd = !this.layoutService.isMobile();
            this.menubarScrollService.atLeftEnd = this.layoutService.isMobile() && !this.jobHasEstimate;
        } else {
            this.menubarScrollService.atLeftEnd = true;
            this.menubarScrollService.atRightEnd = this.layoutService.isMobile() || !this.estimateHasJob;
        }
    }

    ngAfterViewInit() {
        this.#setMenuPositions();
    }

    #setMenuPositions() {
        this.layoutService.isMobile() ? this.#setMobileMenuPosition() : this.#setDesktopMenuPosition();
    }

    #setMobileMenuPosition() {
        this.menuName === MenuName.Job ? this.menubarScrollService.setJobsMenu() : this.menubarScrollService.doLeftMobile(1);
    }

    #setDesktopMenuPosition() {
        this.menuName === MenuName.Job ? this.menubarScrollService.doRight(1) : this.menubarScrollService.resetLeft(this.menuName);
    }
}
